import storage from 'store'
import * as React from 'react'

import { AppEnv } from './di'
import { Icon, Button } from '@design/pt-ui'

const KEY = 'creative-pool-app-env'

export const get = (): AppEnv => {
  if (process.env.NODE_ENV === 'development') {
    return storage.get(KEY) || 'api'
  }

  return 'api'
}

export const set = (env: AppEnv) => {
  return storage.set(KEY, env)
}

export const toggleMock = () => {
  const env = get()

  if (env === 'api') {
    set('mock')
  } else {
    set('api')
  }

  if (typeof window.location !== 'undefined') {
    window.location.reload()
  }
}

export const EnvToggleButton = () => {
  const env = get()

  return (
    <Button
      sx={{
        position: 'absolute',
        top: 6,
        right: 30,
        cursor: 'pointer',
        backgroundColor: env === 'mock' ? 'green' : 'red',
      }}
      variant={'contained'}
      color={env === 'mock' ? 'primary' : 'secondary'}
      title={env === 'mock' ? 'Mock' : 'API'}
      onClick={toggleMock}>
      {env === 'mock' ? <Icon>cloud_off</Icon> : <Icon>cloud</Icon>}
    </Button>
  )
}
